import React from "react";
import Layout from "./layout/Layout";
import AppRouter from "routes/AppRouter";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

export default function App() {
  const { isLoggedIn } = useSelector((state) => state.user);

  return (
    <>
      {!isLoggedIn ? <AppRouter /> : <Layout />}
      <ToastContainer theme="colored" />
    </>
  );
}
